import { render, staticRenderFns } from "./QuestionnaireCreate.vue?vue&type=template&id=487a471a&scoped=true"
import script from "./QuestionnaireCreate.vue?vue&type=script&lang=js"
export * from "./QuestionnaireCreate.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireCreate.vue?vue&type=style&index=0&id=487a471a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a471a",
  null
  
)

export default component.exports